import { atom, useAtom } from "jotai";

const NotebookChatPanelAtom = atom<boolean>(false);

const useToggleNotebookChatPanel = () => {
    const [showPanel, setShowPanel] = useAtom(NotebookChatPanelAtom);
    const toggleDisplay = () => {
        setShowPanel(!showPanel);
    };

    const closePanel = () => {
        setShowPanel(false);
    };
    const openPanel = () => {
        setShowPanel(true);
    };

    return { showPanel, toggleDisplay, closePanel, openPanel };
};

export default useToggleNotebookChatPanel;
